export default (state, getters, rootState) =>  {
    return state.article.filter(i => {
      return i.PageLink.indexOf(rootState.route.fullPath.slice(0,-1)) > -1;
    });
}
